import React from "react";
import { Tree, Form, Icon, Input, Button } from "antd";
const { TreeNode } = Tree;
let columns = () => {
  return [
    {
      title: "品牌",
      name: "brandId",
      dict: {
        wizReplaceData: "getOrg",
        defalutType: []
      },
      searchItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: "请选择品牌"
          }
        ]
      },
      formItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: "请选择品牌"
          }
        ]
      }
    },
    {
      title: "区域",
      name: "zoneId",
      formItem: {},
      searchItem: {}
    },
    {
      title: "岗位",
      name: "positionId",
      dict: {
        wizReplaceData: "getPosition",
        defalutType: []
      },
      searchItem: {
        type: "select",
        // mode: 'multiple',
        rules: [
          {
            required: true,
            message: "请选择岗位"
          }
        ]
      },
      formItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: "请选择岗位"
          }
        ]
      }
    },
    {
      title: "经销商",
      name: "dealerName",
      searchItem: {},
      formItem: {}
    },
    {
      title: "开店状态",
      name: "status",
      dict: [
        { code: "Enable", codeName: "已开店" },
        { code: "Construct", codeName: "建设中" }
      ],
      searchItem: { type: "select" },
      formItem: { type: "select" }
    },
    {
      title: "学员姓名",
      name: "nickName",
      searchItem: {},
      formItem: {}
    },
    {
      title: "学员账号",
      name: "userName",
      searchItem: {},
      formItem: {}
    },
    {
      title: "Form可选参数组件:时间",
      name: "line",
      formItem: {
        type: "line"
      }
    },
    {
      title: "日期范围",
      name: "time1",
      formItem: {
        type: "date~"
      }
    },
    {
      title: "日期时间",
      name: "time2",
      formItem: {
        type: "datetime"
      },
      searchItem: {}
    },
    {
      title: "日期",
      name: "time3",
      formItem: {
        type: "date"
      },
      searchItem: {}
    },
    {
      title: "月",
      name: "time4",
      formItem: {
        type: "month"
      }
    },
    {
      title: "时间",
      name: "time5",
      formItem: {
        type: "time"
      }
    },
    {
      title: "Form可选参数组件:密码",
      name: "line2",
      formItem: {
        type: "line"
      }
    },
    {
      title: "密码",
      name: "password",
      formItem: {
        type: "password",
        name: "密保"
      }
    },
    {
      title: "Form可选参数组件:editor",
      name: "line3",
      formItem: {
        type: "line"
      }
    },
    {
      title: "editor",
      name: "editor",
      formItem: {
        type: "editor"
      }
    },
    {
      title: "Form可选参数组件:checkbox",
      name: "line4",
      formItem: {
        type: "line"
      }
    },
    {
      title: "多选",
      name: "checkbox",
      formItem: {
        type: "checkbox",
        dict: [
          { code: "1", codeName: "1" },
          { code: "2", codeName: "2" }
        ]
      }
    },
    {
      title: "Form可选参数组件:radio",
      name: "line-radio",
      formItem: {
        type: "line"
      }
    },
    {
      title: "单选",
      name: "radio",
      formItem: {
        type: "radio",
        dict: [
          { code: "1", codeName: "1" },
          { code: "2", codeName: "2" }
        ]
      }
    },
    {
      title: "Form可选参数组件:select",
      name: "line5",
      formItem: {
        type: "line"
      }
    },
    {
      title: "选择框",
      name: "select",
      dict: [
        { code: "Enable", codeName: "已开店" },
        { code: "Construct", codeName: "建设中" }
      ],
      formItem: { type: "select" }
    },
    {
      title: "Form可选参数组件:cascade",
      name: "line6",
      formItem: {
        type: "line"
      }
    },
    {
      title: "级联选择",
      name: "cascade",
      formItem: {
        type: "cascade",
        options: [
          {
            value: "zhejiang",
            label: "Zhejiang",
            children: [
              {
                value: "hangzhou",
                label: "Hangzhou",
                children: [
                  {
                    value: "xihu",
                    label: "West Lake"
                  }
                ]
              }
            ]
          },
          {
            value: "jiangsu",
            label: "Jiangsu",
            children: [
              {
                value: "nanjing",
                label: "Nanjing",
                children: [
                  {
                    value: "zhonghuamen",
                    label: "Zhong Hua Men"
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    {
      title: "Form可选参数组件:数字",
      name: "line7",
      formItem: {
        type: "line"
      }
    },
    {
      title: "数字",
      name: "number",
      formItem: {
        type: "number"
      }
    },
    {
      title: "Form可选参数组件:表格",
      name: "line-table",
      formItem: {
        type: "line"
      }
    },
    {
      title: "表格",
      name: "table",
      formItem: {
        type: "table",
        rowKey: "id",
        dataSource: {
          list: [
            { id: 1, name: "张三" },
            { id: 2, name: "李四" },
            { id: 3, name: "王五" }
          ],
          pageNum: 1,
          pageSize: 10,
          total: 10,
          totalPages: 1
        },
        columns: [{ title: "姓名", name: "name" }],
        onChange: (form, value) => console.log("。。。:", value),
        loadData: self.onLoadTableData,
        initialValue: [2]
      }
    },
    {
      title: "Form可选参数组件:穿梭框",
      name: "line-transfer",
      formItem: {
        type: "line"
      }
    },
    {
      title: "穿梭框",
      name: "transfer",
      formItem: {
        type: "transfer",
        modal: true,
        dataSource: [
          { key: 1, title: "张三" },
          { key: 2, title: "李四" },
          { key: 3, title: "王五" }
        ],
        normalize: value => value.map(item => item.title)
      }
    },
    {
      title: "Form可选参数组件:穿梭树",
      name: "line-transfertree",
      formItem: {
        type: "line"
      }
    },
    {
      title: "穿梭树",
      name: "transfertree",
      formItem: {
        type: "transfertree",
        modal: true,
        dataSource: [
          { key: 1, title: "张三" },
          { key: 2, title: "李四" },
          { key: 3, title: "王五" }
        ],
        normalize: value => value.map(item => item.title)
      }
    }
  ];
};

/**
 * 组成部分的参数
 * @param {*} e
 */
let templateConfig = e => {
  let { _btnFun } = e;
  return {
    // header: {
      
    // },
    mainProps: {},
    // sider: {
    //   name: "WizTree",
    //   params: {
    //     checkable: true,
    //     children: [
    //       123
    //     ]
    //   },
    //   componentProps: {
    //     theme: "light",
    //     style: {
    //       marginRight: 15,
    //       minHeight: "calc(100vh - 132px)"
    //     }
    //   }
    // },
    content: {
      name: "WizTableList",
      params: {
        columns: columns(),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttons: [
            {
              key: "refresh",
              custom: true,
              params: { icon: "reload", children: "刷新" },
              customOnClick: {
                //'customOnClick:fun'
                key: "action",
                params: {
                  apiKey: "list",
                  apiParams: { pageNum: 1, pageSize: 10 }
                }
              }
            },
            {
              key: "connat",
              custom: true,
              params: { icon: "loading", children: "联动操作(刷新)" },
              customOnClick: {
                key: "connat",
                params: {
                  apiKey: "list",
                  apiParams: { pageNum: 1, pageSize: 10 }
                }
              },
              needSelect: true
            },
            {
              key: "modal",
              custom: true,
              params: { icon: "folder", children: "modal示例" },
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "Modal",
                    children: "Bla bla .."
                  }
                }
              }
            },
            {
              name: "WizButton",
              params: {
                children: "自定义事件",
                key: "_btn",
                type: "danger"
              },
              onClick: e => _btnFun && _btnFun(e)
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "userName",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateView: [
          {
            key: "modal",
            custom: true,
            params: { icon: "folder" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "Modal",
                  children: "Bla bla .."
                }
              }
            }
          }
        ],
        commonOperate: {}
      }
    }
  };
};

/**
 * reduxTemplate组件的参数
 * @param  {...any} e
 */
let reduxTemplateCofig = (...e) => {
  let _e = {};
  e &&
    e.forEach(element => {
      _e = { ..._e, ...element };
    });
  return {
    componentName: "test",
    apis: {
      getPosition: {
        path: "position/getPosition",
        payload: {
          key: "test@position",
          apiParams: {}
        }
      },
      getOrg: {
        path: "org/getOrg",
        payload: {
          key: "test@org",
          apiParams: {}
        }
      },
      list: {
        path: "personPathReport/getPersonPathReport",
        payload: {
          key: "test@personPathReport",
          apiParams: { pageNum: 1, pageSize: 10 }
        }
      }
    },
    initApiKeys: ["getPosition", "getOrg"],
    needLoading: false,
    ..._e
  };
};

export { reduxTemplateCofig, templateConfig };
